import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HistoryEventService {
  private event$: BehaviorSubject<
    keyof typeof EVENT | null
  > = new BehaviorSubject(null as keyof typeof EVENT | null);

  setEvent(event: keyof typeof EVENT) {
    this.event$.next(event);
  }

  resetEvent() {
    this.event$.complete();
  }

  createEvent(event: keyof typeof EVENT | null) {
    this.event$ = new BehaviorSubject(event);
  }

  getEvent() {
    return this.event$.asObservable();
  }
}

export enum EVENT {
  history,
  account,
  subscription
}
